import React from "react";
import Slider from "react-slick";

import imgS1 from "../../assets/image/home-6/png/screenshot-1.png";
import imgS2 from "../../assets/image/home-6/png/screenshot-2.png";
import imgS3 from "../../assets/image/home-6/png/screenshot-3.png";
import imgS4 from "../../assets/image/home-6/png/screenshot-4.png";
import imgS5 from "../../assets/image/home-6/png/screenshot-5.png";
import imgS6 from "../../assets/image/home-6/png/screenshot-6.png";

const Pricing = ({ className, ...rest }) => {
  const slickSettingsMobile = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    centerMode: true,
    centerPadding: "0px",
    autoplay: true,
    autoplaySpeed: 3000,
    easing: "linear",
    speed: 500,
    appendDots: (dots) => (
      <>
        <div className="screenshots-dots pt-5 pt-md-10">
          <div className="slick-dots">{dots}</div>
        </div>
      </>
    ),

    responsive: [
      {
        breakpoint: 1800,
        settings: {
          slidesToShow: 5,
          centerPadding: "100px",
        },
      },
      {
        breakpoint: 1750,
        settings: {
          slidesToShow: 5,
          centerPadding: "20px",
        },
      },
      {
        breakpoint: 1670,
        settings: {
          slidesToShow: 4,
          centerPadding: "60px",
        },
      },
      {
        breakpoint: 1640,
        settings: {
          slidesToShow: 3,
          centerPadding: "20px",
        },
      },
      {
        breakpoint: 1550,
        settings: {
          slidesToShow: 3,
          centerPadding: "30px",
        },
      },
      {
        breakpoint: 1450,
        settings: {
          slidesToShow: 3,
          centerPadding: "10px",
        },
      },
      {
        breakpoint: 1350,
        settings: {
          slidesToShow: 3,
          centerPadding: "20px",
        },
      },
      {
        breakpoint: 1250,
        settings: {
          slidesToShow: 3,
          centerPadding: "10px",
        },
      },
      {
        breakpoint: 1150,
        settings: {
          slidesToShow: 3,
          centerPadding: "0px",
        },
      },
      {
        breakpoint: 1050,
        settings: {
          slidesToShow: 1,
          centerPadding: "10px",
        },
      },
      {
        breakpoint: 950,
        settings: {
          slidesToShow: 1,
          centerPadding: "0",
        },
      },
      {
        breakpoint: 850,
        settings: {
          slidesToShow: 1,
          centerPadding: "20px",
        },
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          centerPadding: "20px",
        },
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 1,
          centerPadding: "10px",
        },
      },
      {
        breakpoint: 515,
        settings: {
          slidesToShow: 1,
          autoplay: false,
          centerPadding: "0px",
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          autoplay: false,
          centerPadding: "0px",
        },
      },
    ],
  };  
  return (
    <>  
    <div className={className} {...rest}>
      <div className="container">
        {/* section title */}
        <div className="row justify-content-center">
          <div className="col-12">
            <div
              className="text-center mb-8 dark-mode-texts"
              data-aos="fade-up"
              data-aos-delay={500}
              data-aos-once="true"
            >
              <h2 className="font-size-10 mb-2 letter-spacing-n83">
                Digma User Experience
              </h2>

            </div>
          </div>
        </div>
        {/* section title */}
        {/* Pricing Table */}
        <Slider
          {...slickSettingsMobile}
          css={`
            .slick-dots {
              display: flex !important;
            }
          `}
          className="screenshot-slider"
        >
          <div className="single-slide focus-reset">
            <div className="screenshot-image">
              <img src={imgS1} alt="Digma Interactive Video Mobile Version" />
            </div>
          </div>
          <div className="single-slide focus-reset">
            <div className="screenshot-image">
              <img src={imgS2} alt="Digma Interactive Video Mobile Version" />
            </div>
          </div>
          <div className="single-slide focus-reset">
            <div className="screenshot-image">
              <img src={imgS3} alt="Digma Interactive Video Mobile Version" />
            </div>
          </div>
          <div className="single-slide focus-reset">
            <div className="screenshot-image">
              <img src={imgS4} alt="Digma Interactive Video Mobile Version" />
            </div>
          </div>
          <div className="single-slide focus-reset">
            <div className="screenshot-image">
              <img src={imgS5} alt="Digma Interactive Video Mobile Version" />
            </div>
          </div>
          <div className="single-slide focus-reset">
            <div className="screenshot-image">
              <img src={imgS6} alt="Digma Interactive Video Mobile Version" />
            </div>
          </div>
        </Slider>
        {/* End Pricing Table */}
      </div>
    </div>
    </>
  );
};

export default Pricing;
